import moment from 'moment';
import {
    EBFL1RecordCode,
    EBFL1RecordState,
    TBFL1CommonData,
    TBFL1CommonFields,
} from '../@types';
import { EMARPOLDocuments } from '../../marpol/@types';

export type TBFL1ItemC1 =
    | {
          place: 'PORT';
          portName: string;
      }
    | {
          place: 'AT_SEA';
          startPosition: {
              latitude: string;
              longitude: string;
          };
          stopPosition: {
              latitude: string;
              longitude: string;
          };
      };
export type TBFL1ItemC2 = {
    remarks: string;
};
export type TBFL1ItemC3 = {
    remarks: string;
};
export type TBFL1ItemC4 = {
    remarks: string;
};
export type TBFL1ItemC5 = {
    remarks: string;
};
export type TBFL1ItemC6 = {
    remarks: string;
};
export type TBFL1ItemC7 = {
    remarks: string;
};

export type TBFL1ItemC9 = {
    remarks: string;
};
export type TBFL1ItemC10 = {
    remarks: string;
};

export type TBFL1C1 = TBFL1CommonFields &
    TBFL1CommonData & {
        recordCode: EBFL1RecordCode.BFL1C1;
        item1: TBFL1ItemC1;
        item2: TBFL1ItemC2;
        item3: TBFL1ItemC3;
        item4: TBFL1ItemC4;
        item5: TBFL1ItemC5;
        item6: TBFL1ItemC6;
        item7: TBFL1ItemC7;
        item9: TBFL1ItemC9;
        item10: TBFL1ItemC10;
    };

export type TBFL1GroupC = TBFL1C1;

const BFL1_GROUPC_DEFAULTS: {
    C1: TBFL1C1;
} = {
    C1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL1,
        state: EBFL1RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            place: 'AT_SEA',
            startPosition: {
                latitude: '',
                longitude: '',
            },
            stopPosition: {
                latitude: '',
                longitude: '',
            },
        },
        item2: { remarks: '' },
        item3: { remarks: '' },
        item4: { remarks: '' },
        item5: { remarks: '' },
        item6: { remarks: '' },
        item7: { remarks: '' },
        item9: { remarks: '' },
        item10: { remarks: '' },
        recordCode: EBFL1RecordCode.BFL1C1,
        processedTanks: [],
    },
};

export { BFL1_GROUPC_DEFAULTS };
